import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import Transition from './common/Transition';

const CdiRenewOptionsDialog = ({ open, onClose, onRenewCdi, onChangeContract }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      TransitionComponent={Transition}
      keepMounted
      slotProps={{ paper: {
        sx: {
          borderRadius: 6,
          background: 'rgba(255, 255, 255, 0.75)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          overflow: 'hidden',
        }
      } }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          fontFamily: `'Orbitron', 'Segoe UI', sans-serif`,
          fontWeight: 700,
          fontSize: '1.3rem',
          textTransform: 'uppercase',
          letterSpacing: '0.8px',
          color: '#0f172a',
          pt: 4,
        }}
      >
        Renouvellement de contrat CDI
      </DialogTitle>

      <DialogContent sx={{ px: 4, pt: 2, pb: 3 }}>
        <Typography
          variant="body1"
          align="center"
          sx={{
            fontFamily: `'Segoe UI', Roboto, sans-serif`,
            color: '#334155',
            fontSize: '1rem',
            letterSpacing: '0.3px',
          }}
        >
          Souhaitez-vous renouveler le contrat CDI ou changer le type de contrat ?
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'center',
          gap: 2,
          px: 3,
          pb: 4,
          flexWrap: 'wrap'
        }}
      >
        <Button
          variant="outlined"
          onClick={onChangeContract}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: '20px',
            px: 3,
            py: 1,
            borderColor: '#3b82f6',
            color: '#3b82f6',
            '&:hover': {
              background: '#eff6ff',
              borderColor: '#1e3a8a',
            },
          }}
        >
          Changer contrat
        </Button>

        <Button
          variant="contained"
          onClick={onRenewCdi}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: '20px',
            px: 3,
            py: 1,
            background: 'linear-gradient(90deg, #3b82f6, #03407b)',
            color: '#fff',
            boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
            '&:hover': {
              background: 'linear-gradient(90deg, #2563eb, #02357a)',
            },
          }}
        >
          Renouveler le CDI
        </Button>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: '20px',
            px: 3,
            py: 1,
            color: '#c026d3',
            borderColor: '#c026d3',
            '&:hover': {
              background: '#fce7f3',
              borderColor: '#a21caf',
            },
          }}
        >
          Annuler
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CdiRenewOptionsDialog;